// Favorites & recent items persisted in localStorage
const FAV_KEY = "sarabi:favorites";
const RECENT_KEY = "sarabi:recent";
const RECENT_MAX = 10;

function safeGet(k, def) {
  try { return JSON.parse(localStorage.getItem(k) || JSON.stringify(def)); } catch { return def; }
}
function safeSet(k, v) {
  try { localStorage.setItem(k, JSON.stringify(v)); } catch {}
}

export function getFavorites() {
  return safeGet(FAV_KEY, { products: [], categories: [], pages: [] });
}
export function toggleFavorite(kind, id) {
  const f = getFavorites();
  const list = f[kind] || [];
  const has = list.includes(id);
  f[kind] = has ? list.filter((x) => x !== id) : [id, ...list];
  safeSet(FAV_KEY, f);
  window.dispatchEvent(new Event("favorites-changed"));
  return !has;
}
export function isFavorite(kind, id) {
  return (getFavorites()[kind] || []).includes(id);
}

export function getRecent() {
  return safeGet(RECENT_KEY, []);
}
export function pushRecent(item) {
  if (!item || !item.id) return;
  const cur = getRecent().filter((x) => x.id !== item.id);
  const next = [{ ...item, at: new Date().toISOString() }, ...cur].slice(0, RECENT_MAX);
  safeSet(RECENT_KEY, next);
  window.dispatchEvent(new Event("recent-changed"));
}
